import React, { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { Star, Trophy } from "lucide-react";

export const StarClubPositions = () => {
  const [data, setData] = useState(null);

  const load = useCallback(async () => {
    try {
      const r = await api.get("/me/star-club");
      setData(r.data);
    } catch (err) {
      console.warn("Global Club positions load failed:", err?.message);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const completed = data?.completed_entries || [];

  return (
    <div className="lt-card p-6" data-testid="dash-star-club-positions">
      <div className="overline mb-4 flex items-center gap-2">
        <Star size={14} className="text-[#D4AF37]" /> Global Club Positions
      </div>

      {completed.length > 0 ? (
        <div data-testid="sc-completed-block">
          <div className="overline mb-2 flex items-center gap-2">
            <Trophy size={12} className="text-[#D4AF37]" /> Completed
          </div>
          <div className="flex flex-wrap gap-2">
            {completed.map((c) => (
              <span
                key={c.id || `${c.club}-${c.position}`}
                className="px-3 py-1.5 rounded-full bg-[#D4AF37]/10 border border-[#D4AF37]/30 text-xs gold-text tabular"
                data-testid={`sc-completed-club-${c.club}`}
              >
                Club {c.club}
              </span>
            ))}
          </div>
        </div>
      ) : (
        <div className="text-sm text-neutral-400" data-testid="sc-positions-empty">
          No completed Global Clubs yet.
        </div>
      )}
    </div>
  );
};
